import { createAsyncThunk } from '@reduxjs/toolkit';
import * as api from '../../api/newsApi';

export const getUsersUpdates = createAsyncThunk(
  'news/getUsersUpdates',
  async (params, thunkAPI) => {
    try {
      const response = await api.getAllNews({ ...params, type: 'updates' });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  },
);

export const getTestimonials = createAsyncThunk(
  'news/getTestimonials',
  async (params, thunkAPI) => {
    try {
      const response = await api.getAllNews({
        ...params,
        type: 'testimonials',
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  },
);
export const getVideoStories = createAsyncThunk(
  'news/getVideoStories',
  async (params, thunkAPI) => {
    try {
      const response = await api.getAllNews({
        ...params,
        type: 'video stories',
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  },
);

export const getNews = createAsyncThunk(
  'news/getNews',
  async (params, thunkAPI) => {
    try {
      const response = await api.getAllNews({
        ...params,
        type: 'news',
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  },
);

export const createNews = createAsyncThunk(
  'news/createNews',
  async (news, thunkAPI) => {
    try {
      const response = await api.createNews(news);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  },
);

export const deleteNews = createAsyncThunk(
  'news/deleteNews',
  async (newsId, thunkAPI) => {
    try {
      await api.deleteNews(newsId);
      return newsId;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  },
);
